import { render } from "./XIconSolidGlobe.vue?vue&type=template&id=4c19e7d0"
import script from "./XIconSolidGlobe.vue?vue&type=script&lang=js"
export * from "./XIconSolidGlobe.vue?vue&type=script&lang=js"

import exportComponent from "/home/omid_es327/Projects/mohovers/dev/dev-laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"XIconSolidGlobe.vue"]])

export default __exports__